import React, { useState } from 'react';
import { Menu, X, Phone, MapPin } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full backdrop-blur-sm border-b border-gray-700" style={{ backgroundColor: 'rgba(26, 21, 18, 0.95)' }}>
      <div className="container mx-auto px-4">
        {/* Top Bar */}
        <div className="flex items-center justify-between py-2 text-sm border-b border-gray-700" style={{ borderColor: 'var(--border-medium)' }}>
          <div className="flex items-center space-x-4" style={{ color: 'var(--text-secondary)' }}>
            <div className="flex items-center space-x-1">
              <MapPin size={14} />
              <span>Located inside <a href="/favorite-places#alexander-medical-center" className="underline hover:no-underline" style={{ color: 'var(--brand-primary)' }}>Alexander Medical Center</a>, Gilbert AZ</span>
            </div>
          </div>
          <a href="/contact?focus=contact" className="flex items-center space-x-1" style={{ color: 'var(--brand-primary)' }}>
            <Phone size={14} />
            <span>Schedule Your Consultation</span>
          </a>
        </div>

        {/* Main Navigation */}
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--secondary-brown)' }}>
              <span className="text-white font-bold text-lg">GR</span>
            </div>
            <div>
              <h1 className="text-xl font-bold uppercase tracking-tight" style={{ color: 'var(--secondary-brown)' }}>
                GymRatRehab
              </h1>
              <p className="text-xs uppercase tracking-wide" style={{ color: 'var(--text-secondary)' }}>
                Physical Therapy
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/" className="nav-link">Home</a>
            <a href="/services" className="nav-link">Services</a>
            <a href="/pricing" className="nav-link">Pricing</a>
            <a href="/about" className="nav-link">About</a>
            <a href="/faq" className="nav-link">FAQ</a>
            <a href="/blog" className="nav-link">Blog</a>
            <a href="/favorite-places" className="nav-link">My Favorites</a>
            <a href="/contact?focus=contact" className="nav-link">Contact</a>
            <button 
              className="btn-primary"
              onClick={() => {
                window.location.href = '/contact?focus=contact';
              }}
            >
              Book Appointment
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-lime-400"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t" style={{ borderColor: 'var(--border-medium)' }}>
            <div className="flex flex-col space-y-4">
              <a href="/" className="nav-link">Home</a>
              <a href="/services" className="nav-link">Services</a>
              <a href="/pricing" className="nav-link">Pricing</a>
              <a href="/about" className="nav-link">About</a>
              <a href="/faq" className="nav-link">FAQ</a>
              <a href="/blog" className="nav-link">Blog</a>
              <a href="/favorite-places" className="nav-link">My Favorites</a>
              <a href="/contact?focus=contact" className="nav-link">Contact</a>
              <button 
                className="btn-primary mt-4"
                onClick={() => {
                  window.location.href = '/contact?focus=contact';
                }}
              >
                Book Appointment
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};